/**
 * About page copy, adapted from `Bluebird About.dc.html`.
 * See `shop.ts` for what may and may not change in a copy pass.
 *
 * The staff bios below say only what Ryan established in the 2026-08-25
 * meeting. The names and photographs came from his follow-up email. Do not
 * enrich these entries; a bio is exactly where plausible details get invented.
 */
export const about = {
  hero: {
    line1: "Family-owned in Boulder, CO",
    line2: "focused on cargo bikes",
    intro:
      "School runs, grocery stops, and a little more time outside. We’ll help you find a cargo bike that fits your family. Bring the kids and your questions—we’ll start with a ride.",
    photoNote:
      "photo, full-bleed — the roll-up door open to the street, floor of bikes visible",
  },

  story: {
    heading: "Come meet the people behind the bikes",
    body1:
      "Ryan built his first cargo bike in 2003 and has ridden one since. That experience is most useful when you are comparing passenger space, handling, storage, accessories, and the routes your family rides.",
    body2:
      "The shop carries Tern, Urban Arrow, Xtracycle, Riese & Müller, Benno, Gazelle, and Flyer. You can compare the current bikes in one visit and take the strongest options onto the creek path behind the shop.",
    imageSrc: "/images/team/ryan_riding.jpg",
    imageAlt: "Ryan riding a family cargo bike on a bridge",
  },

  who: {
    heading: "A small, family-owned shop",
    people: [
      {
        kind: "person",
        name: "Ryan",
        role: "Owner. Built his first cargo bike in 2003.",
        imageSrc: "/images/team/ryan_shop.jpg",
        imageAlt: "Ryan seated on a cargo bike inside the shop",
      },
      {
        kind: "person",
        name: "Zach",
        role: "Mechanic. Services cargo bikes purchased from the shop.",
        imageSrc: "/images/team/zach_shop.jpg",
        imageAlt: "Zach holding bike tools inside the shop",
      },
      {
        kind: "dog",
        name: "Koa & Tallie",
        role: "Shop dogs.",
        imageSrc: "/images/team/koa_tallie.jpg",
        imageAlt: "Koa and Tallie, two of the shop dogs",
      },
      {
        kind: "dog",
        name: "Brodie",
        role: "Shop dog.",
        imageSrc: "/images/team/brodie.jpg",
        imageAlt: "Brodie, the small shop dog, sitting in a cargo bike",
      },
    ],
  },

  visit: {
    heading: "Plan your visit",
    body:
      "Schedule ahead so the bikes most likely to fit are ready. Bring the children or cargo you expect to carry for a free 30-minute test ride.",
    cta: "Schedule a test ride",
    note: "Walk-ins are welcome during open hours; scheduling gives us time to prepare the bikes.",
  },

  ride: {
    heading: "Bring the family. Try a few bikes.",
    body:
      "Compare handling, passenger space, starting, stopping, and parking on a free 30-minute ride. No purchase required.",
    primary: "Schedule a test ride",
    secondary: "See the bikes",
  },
} as const;
